// Every rule number in this file is read off `docs/rulebook.pdf` - the
// official Sunriver Games rulebook (c) 2006 - and cites the page it came
// from. Do not "fix" one of these from memory.
//
// Incan Gold is the 2006 Sunriver/Gryphon re-issue of Bruno Faidutti and Alan
// R. Moon's *Diamant* (2005). The rules are the same game plus Artifacts; the
// rulebook says so itself on p4: "Artifacts are new to this edition of the
// game. To play the original Diamant rules, simply remove the Artifacts from
// the game. Everything else stays the same."

/** p1 COMPONENTS: "5 Temple cards to make the game board". */
export const ROUNDS = 5;

/**
 * p1 COMPONENTS: "16 Player cards (8 Torch cards and 8 Camp cards)" and "8
 * Tent cards". Eight of everything a player needs, so eight is the ceiling.
 *
 * The rulebook never states a minimum in prose; the box says 3-8, and the
 * game degenerates below three (with two players a lone leaver is simply
 * whoever leaves first, and the "will anybody else bail this turn?" read -
 * which is the entire game - has no room to exist).
 */
export const MIN_PLAYERS = 3;
export const MAX_PLAYERS = 8;

/**
 * p1 COMPONENTS: "30 Quest cards, 15 Treasure cards and 15 Hazard cards (3
 * each of 5 hazards)" plus "5 Artifact cards".
 *
 * The fifteen treasure values are printed on the cards, not generated - they
 * are not an arithmetic series and must not be smoothed into one. Sum: 124.
 */
export const TREASURE_VALUES = [1, 2, 3, 4, 5, 5, 7, 7, 9, 11, 11, 13, 14, 15, 17];

/**
 * The five hazards, named for the art in the Tabletop Simulator mod this
 * game's card faces come from.
 *
 * That mod is a *Diamant* deck, so its fifth hazard is a spiked deadfall trap
 * where Incan Gold's own art has a mummy. Identical mechanically - a hazard
 * type is just an identity to match a second copy against - and naming them
 * after the pictures the player is actually looking at beats naming them
 * after a card this deck doesn't contain.
 */
export const HAZARDS = ['lava', 'spikes', 'boulder', 'snake', 'spider'];

/**
 * What to call each hazard in a sentence. "A second spikes" is not English,
 * and the plural ones read wrong in the singular too.
 */
export const HAZARD_LABELS = {
  lava: 'lava flow',
  spikes: 'spike trap',
  boulder: 'rolling boulder',
  snake: 'nest of snakes',
  spider: 'swarm of spiders',
};

/** p1: "3 each of 5 hazards". */
export const COPIES_PER_HAZARD = 3;

/** p1: "5 Artifact cards". */
export const ARTIFACT_COUNT = 5;

/**
 * p3: "The first three Artifacts to leave the Temple are worth 5 points each.
 * [...] Any further Artifacts that leave the Temple are worth 10 points".
 *
 * Note what this counts: artifacts that have LEFT the temple, across the
 * whole table and the whole game - not per player, and not the order they
 * were revealed in. The fourth artifact anyone gets safely home is worth 10
 * even if it is that player's first.
 */
export const ARTIFACT_EARLY_VALUE = 5;
export const ARTIFACT_LATE_VALUE = 10;
export const ARTIFACTS_AT_EARLY_VALUE = 3;

export const CARD_KINDS = {
  TREASURE: 'treasure',
  HAZARD: 'hazard',
  ARTIFACT: 'artifact',
};

export const PHASES = {
  /** Everyone still in the temple is choosing torch-or-camp. */
  DECIDING: 'deciding',
  /** Five rounds are done and the tents are open. */
  FINISHED: 'finished',
};

/** What a player chose this turn. p2: the Torch card, or the Camp card. */
export const CHOICES = {
  CONTINUE: 'continue',
  LEAVE: 'leave',
};

/** How a round ended, for the log and the round-summary banner. */
export const ROUND_END_REASONS = {
  /** p3: "When all players have left the Temple". */
  EVERYONE_LEFT: 'everyone-left',
  /** p3: "when the second Hazard card of the same type is drawn". */
  HAZARD: 'hazard',
};
